<template>
  <load-area v-if="providers == null"></load-area>
  <div v-if="providers != null">
    <Form
      method="dialog"
      v-slot="{ errors }"
      class="floating-labels row  p-20 p-b-10"
      ref="form"
    >
      <div class="col">
        <formGroup
          :title="'ReservationId'"
          v-model="model.ReservationId"
          :errors="errors"
          @keydown.enter="get()"
          :buttons="true"
        >
          <template #buttons>
            <Btn
              class="btn btn-success btn-xs waves-effect text-center"
              @click="get()"
              :process="process"
              ><span class="fa fa-search"></span
            ></Btn>
          </template>
        </formGroup>
      </div>
      <div
        class="col"
        v-if="providerId == undefined && customerProviderId == undefined"
      >
        <!-- <formGroup
          :title="'ProviderId'"
          :as="'select'"
          :disabled="providers.length == 0"
          v-model="model.ProviderId"
          :errors="errors"
        >
          <template #input>
            <option :value="null"></option>
            <option
              v-for="item in $orderByArray(providers, 'Name', false, false)"
              :value="item.Id"
              :key="item.Code"
              >{{ item.Name }}</option
            >
          </template>
        </formGroup> -->
        <searchSelect
          :title="'ProviderId'"
          v-model="model.ProviderId"
          :rules="{ required: true }"
          :errors="errors"
          :data="
            $orderByArray(
              providers.map((x) => {
                return {
                  value: x.Id,
                  text: x.Name,
                };
              }),
              'text',
              false,
              false
            )
          "
        >
        </searchSelect>
      </div>
      <div class="col">
        <formGroup
          :title="'LogType'"
          :as="'select'"
          v-model="model.LogType"
          :errors="errors"
        >
          <template #input>
            <option :value="null"></option>
            <option value="auth">Auth</option>
            <option value="scan">Scan</option>
            <option value="confirm">Confirm</option>
            <option value="notconfirm">Not Confirm</option>
            <option value="download">Download</option>
          </template>
        </formGroup>
      </div>
      <div class="col">
        <formGroup
          :title="'StartDate'"
          :type="'date'"
          :max="model.EndDate"
          v-model="model.StartDate"
          :errors="errors"
          @keydown.enter="get"
        ></formGroup>
      </div>
      <div class="col">
        <formGroup
          :title="'EndDate'"
          :type="'date'"
          :min="model.StartDate"
          v-model="model.EndDate"
          :errors="errors"
          @keydown.enter="get"
        ></formGroup>
      </div>
      <div class="col-auto">
        <Btn
          class="btn-success"
          @click="get()"
          :disabled="reportProcess"
          :process="reportProcess"
          >Get</Btn
        >
      </div>
    </Form>
    <dataTable
      :name="'kolayrezCustomerProviderLogs'"
      v-if="data != null && !reportProcess"
      ref="agGrid"
      :columnDefs="columnDefs"
      :data="data"
      :rowClassRules="{
        // row style function
        danger: (params) => {
          // var numSickDays = params.data;
          return params?.data?.HasError;
        },
      }"
    ></dataTable>
    <load-area v-if="reportProcess" class="border-top"></load-area>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CustomerProviderLogs",
  props: ["providerId", "customerProviderId"],
  data() {
    return {
      providers: null,
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          field: "Id",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "C.ProviderId",
          width: 120,
          field: "CustomerProviderId",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
          hide: this.customerProviderId != undefined,
        },
        {
          headerName: "ProviderId",
          width: 110,
          field: "ProviderId",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
          hide: !(
            this.providerId == undefined && this.customerProviderId == undefined
          ),
        },
        {
          headerName: "Res.Id",
          width: 100,
          field: "ReservationId",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        // {
        //   headerName: "ResTypeCount",
        //   field: "sumRes",
        //   filter: false,
        //   width: 140,
        //   sortable: true,
        //   cellClick: true,
        //   enableRowGroup: true,
        //   cellRenderer: function(params) {
        //     if (params.data != undefined) {
        //       let text = "";
        //       let sumCount = 0;
        //       if (params.data.New > 0) {
        //         sumCount++;
        //         text +=
        //           "+<b class='confirmationType new'>" +
        //           params.data.New +
        //           "</b>";
        //       }
        //       if (params.data.Changed > 0) {
        //         sumCount++;
        //         text +=
        //           "+<b class='confirmationType changed'>" +
        //           params.data.Changed +
        //           "</b>";
        //       }
        //       if (params.data.Cancelled > 0) {
        //         sumCount++;
        //         text +=
        //           "+<b class='confirmationType cancelled'>" +
        //           params.data.Cancelled +
        //           "</b>";
        //       }
        //       if (params.data.Booked > 0) {
        //         sumCount++;
        //         text +=
        //           "+<b class='confirmationType booked'>" +
        //           params.data.Booked +
        //           "</b>";
        //       }
        //       if (params.data.Other > 0) {
        //         sumCount++;
        //         text +=
        //           "+<b class='confirmationType'>" + params.data.Other + "</b>";
        //       }
        //       return (
        //         text.replace("+", "") +
        //         (sumCount > 1 ? "=<b>" + params.data.sumRes + "</b>" : "")
        //       );
        //     }
        //   },
        // },
        {
          headerName: "LogType",
          field: "LogType",
          filter: "agTextColumnFilter",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: (e) => {
            return (
              e.value +
              (e.value == "scan"
                ? "-" +
                  (e.data.Booked +
                    e.data.Cancelled +
                    e.data.Changed +
                    e.data.New +
                    e.data.Other)
                : "")
            );
          },
        },
        {
          headerName: "Proxy",
          field: "proxy",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Worker",
          field: "Worker",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Source",
          field: "Source",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Date",
          field: "Date",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "Username",
          field: "Username",
          filter: "agTextColumnFilter",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Password",
          field: "Password",
          filter: "agTextColumnFilter",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Parameter",
          field: "Parameter",
          filter: "agTextColumnFilter",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "A.Failure",
          width: 100,
          field: "AuthenticationFailure",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "ErrorMessage",
          field: "ErrorMessage",
          filter: "agTextColumnFilter",
          minWidth: 240,
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
      ],
      data: null,
      model: {
        ProviderId: null,
        LogType: null,
        CustomerProviderId: null,
        ReservationId: null,
        StartDate: null,
        EndDate: null,
      },
      reportProcess: false,
      report: [],
    };
  },
  created() {
    if (this.providerId != undefined) {
      this.model.ProviderId = this.providerId;
    }
    if (this.customerProviderId != undefined) {
      this.model.CustomerProviderId = this.customerProviderId;
    }
    this.$appAxiosAdmin.get(`kolayrez/Providers`).then((response) => {
      this.providers = response.data;
    });
    // this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.reportProcess = true;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reports/CustomerProvidersLogs`, this.model)
        .then((response) => {
          this.data = this.$orderByArray(
            response.data.map((x) => {
              return {
                ...x,
                sumRes: x.New + x.Changed + x.Cancelled + x.Booked + x.Other,
                proxy: x.ProxyIP == null ? null : x.ProxyIP + ":" + x.ProxyPort,
              };
            }),
            "Name",
            true,
            false,
            true
          );
          this.reportProcess = false;
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
          this.data = [];
          this.reportProcess = false;
        });
    },
    reload() {
      this.get();
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
